import _ from 'lodash';
import React from 'react';
import { AccordionContainer } from '../../../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../../../common/components/form/form.module';

export const OpenNetworkLogBasicInfoComponent = ({
    selectOpenNetworkLogs, handleInnerFormChange, actionList, domainList
}: any) => {
    const dateRangesList: any = [
        { Description: '15 mins', Value: 10 },
        { Description: '30 mins', Value: 20 },
        { Description: '! hour', Value: 30 },
        { Description: '4 hours', Value: 40 },
        { Description: '8 hours', Value: 50 },
        { Description: '12 hours', Value: 60 },
        { Description: '24 hours', Value: 70 },
        { Description: '48 hours', Value: 80 },
        { Description: 'Custom', Value: 90 },
    ]

    return (
        <>
            <AccordionContainer
                child={
                    <div className='grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
                        <InputContainer
                            label="Action"
                            labelField="Text"
                            list={actionList}
                            onValueChange={(event: any) => {
                                handleInnerFormChange(
                                    event.target.value,
                                    'Action',
                                );
                            }}
                            optionName='Choose Action Name'
                            type="select"
                            value={selectOpenNetworkLogs?.Action}
                            valueField="Text"
                        />
                        <InputContainer
                            label="Date Range"
                            labelField="Description"
                            list={dateRangesList}
                            onValueChange={(event: any) => {
                                handleInnerFormChange(
                                    event.target.value,
                                    'DurationUnitId',
                                );
                            }}
                            optionName='Choose Date Ranges'
                            type="select"
                            value={selectOpenNetworkLogs?.DurationUnitId}
                            valueField="Description"
                        />
                        {selectOpenNetworkLogs?.DurationUnitId === 'Custom' &&
                            <>
                                <InputContainer
                                    isDateTimePicker
                                    label="Start Date"
                                    name="StartDateOnUtc"
                                    onValueChange={(event: any) => {
                                        handleInnerFormChange(
                                            event.target.value,
                                            'StartDateOnUtc',
                                        );
                                    }}
                                    type="date"
                                    value={selectOpenNetworkLogs?.StartDateOnUtc}
                                />
                                <InputContainer
                                    isDateTimePicker
                                    label="End Date"
                                    name="EndDateOnUtc"
                                    onValueChange={(event: any) => {
                                        handleInnerFormChange(
                                            event.target.value,
                                            'EndDateOnUtc',
                                        );
                                    }}
                                    type="date"
                                    value={selectOpenNetworkLogs?.EndDateOnUtc}
                                />
                            </>
                        }
                        <InputContainer
                            label="Transaction Id"
                            labelField="TransactionId"
                            onValueChange={(event: any, newValue: any) => {
                                handleInnerFormChange(
                                    event.target.value,
                                    'TransactionId',
                                );
                            }}
                            type="text"
                            value={selectOpenNetworkLogs?.TransactionId}
                        />
                        <InputContainer
                            label="Message Id"
                            labelField="MessageId"
                            onValueChange={(event: any, newValue: any) => {
                                handleInnerFormChange(
                                    event.target.value,
                                    'MessageId',
                                );
                            }}
                            type="text"
                            value={selectOpenNetworkLogs?.MessageId}
                        />
                        <InputContainer
                            label="Buyer Id"
                            labelField="BuyerId"
                            onValueChange={(event: any, newValue: any) => {
                                handleInnerFormChange(
                                    event.target.value,
                                    'BuyerId',
                                );
                            }}
                            type="text"
                            value={selectOpenNetworkLogs?.BuyerId}
                        />
                        <InputContainer
                            label="Seller Id"
                            labelField="SellerId"
                            onValueChange={(event: any, newValue: any) => {
                                handleInnerFormChange(
                                    event.target.value,
                                    'SellerId',
                                );
                            }}
                            type="text"
                            value={selectOpenNetworkLogs?.SellerId}
                        />
                        <InputContainer
                            label="Domain"
                            labelField="Name"
                            list={domainList}
                            onValueChange={(event: any) => {
                                handleInnerFormChange(
                                    event.target.value,
                                    'DomainId',
                                );
                            }}
                            optionName='Choose Domain Name'
                            type="select"
                            value={selectOpenNetworkLogs?.DomainId}
                            valueField="Name"
                        />
                        <InputContainer
                            label="City"
                            labelField="City"
                            onValueChange={(event: any, newValue: any) => {
                                handleInnerFormChange(
                                    event.target.value,
                                    'City',
                                );
                            }}
                            type="text"
                            value={selectOpenNetworkLogs?.City}
                        />
                    </div>
                }
                expandedPanel="Logsinfo"
                headerTitle="Search Information"
            />
        </>
    )
}

export default OpenNetworkLogBasicInfoComponent;
